import route from "@/components/router/Router"
const routes = [
    {
        path : "warehouse-carrier-add",
        name : "warehouse-carrier-add",
        meta : {
            title : "仓库载体-载体录入"
        },
        component: () => import('@/pages/warehouse/inputCarrier/Index')
    },
    {
        path : "warehouse-carrier-edit/:id",
        name : "warehouse-carrier-edit",
        meta : {
            title : "仓库载体-载体录入"
        },
        component: () => import('@/pages/warehouse/inputCarrier/Index')
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/warehouse/inputcarrier/index.js